import { SVGProps, Ref, forwardRef } from 'react';

export const RocketOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.256 16.5A3.245 3.245 0 0 1 7.5 19.744l-.012.329c-.236 3.282-4.044 2.914-6.475 2.914 0-2.51-.392-6.487 3.243-6.487m0 1.8c-.562 0-.773.144-.86.22-.116.1-.266.308-.388.755-.154.564-.195 1.207-.203 1.919.712-.008 1.356-.048 1.92-.202.447-.122.655-.273.755-.388.076-.087.22-.299.22-.86 0-.797-.647-1.445-1.444-1.445"
                fill="currentColor"
            />
            <path
                d="M15 7.25c1.312 0 1.75.875 1.75 1.75s-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75.438-1.75 1.75-1.75"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.883 6.877c1.977-2.379 6.853-6.734 12.97-5.73 1.004 6.117-3.351 10.992-5.73 12.969.401 3.29-.816 6.54-4.73 8.884-.14-1.946-.549-3.67-1.228-5.15l-.948.49-4.557-4.558.49-.948c-1.462-.67-3.178-1.085-5.15-1.226 2.27-3.792 5.39-5.054 8.575-4.765zm11.313-4.075c-4.509-.066-8.215 3.164-9.928 5.225l-.628.755-.975-.118c-1.351-.165-2.627.008-3.786.576a6.7 6.7 0 0 0-1.555 1.065q1.367.34 2.575.893l1.713.786-.75 1.454 2.698 2.698 1.455-.75.786 1.713q.555 1.216.891 2.575a6.7 6.7 0 0 0 1.068-1.553c.568-1.16.74-2.436.576-3.787l-.118-.975.755-.627c2.061-1.713 5.29-5.42 5.223-9.93"
                fill="currentColor"
            />
        </g>
    </svg>
));
RocketOutlinedSize24Glyph.displayName = 'RocketOutlinedSize24Glyph';
